(function () {
  var SEL = '.testimonials-coverflow[data-tc-root]';

  function parseBool(v) {
    return v === 'true' || v === true;
  }

  function init(root) {
    if (!root || root.dataset.tcInit === '1') return;
    root.dataset.tcInit = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.testimonials-coverflow__card'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.testimonials-coverflow__dot'));
    var prevBtn = root.querySelector('.testimonials-coverflow__arrow--prev');
    var nextBtn = root.querySelector('.testimonials-coverflow__arrow--next');
    var viewport = root.querySelector('.testimonials-coverflow__viewport');

    if (!cards.length) {
      return;
    }

    var count = cards.length;
    var current = 0;
    var autoTimer = null;
    var autoplay = parseBool(root.getAttribute('data-tc-autoplay'));
    var delay = parseInt(root.getAttribute('data-tc-autoplay-ms') || '2800', 10);
    if (Number.isNaN(delay) || delay < 1500) delay = 2800;
    var pauseHover = parseBool(root.getAttribute('data-tc-pause-hover'));

    function layout(idx) {
      current = ((idx % count) + count) % count;
      var leftIdx = ((current - 1) + count) % count;
      var rightIdx = (current + 1) % count;

      cards.forEach(function (card, i) {
        card.classList.remove(
          'testimonials-coverflow__card--center',
          'testimonials-coverflow__card--left',
          'testimonials-coverflow__card--right',
          'testimonials-coverflow__card--hidden'
        );

        if (i === current) {
          card.classList.add('testimonials-coverflow__card--center');
        } else if (i === leftIdx) {
          card.classList.add('testimonials-coverflow__card--left');
        } else if (i === rightIdx) {
          card.classList.add('testimonials-coverflow__card--right');
        } else {
          card.classList.add('testimonials-coverflow__card--hidden');
        }
      });

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    function next() {
      layout(current + 1);
    }
    function prev() {
      layout(current - 1);
    }

    function startAuto() {
      stopAuto();
      if (!autoplay || count < 2) return;
      autoTimer = setInterval(next, delay);
    }

    function stopAuto() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function onNextClick() {
      next();
      startAuto();
    }
    function onPrevClick() {
      prev();
      startAuto();
    }

    if (nextBtn) nextBtn.addEventListener('click', onNextClick);
    if (prevBtn) prevBtn.addEventListener('click', onPrevClick);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var go = parseInt(dot.getAttribute('data-go') || '0', 10);
        layout(go);
        startAuto();
      });
    });

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        if (!card.classList.contains('testimonials-coverflow__card--center')) {
          layout(i);
          startAuto();
        }
      });
    });

    if (viewport && pauseHover) {
      viewport.addEventListener('mouseenter', stopAuto);
      viewport.addEventListener('mouseleave', startAuto);
    }

    var touchX = 0;
    if (viewport) {
      viewport.addEventListener(
        'touchstart',
        function (e) {
          touchX = e.touches[0].clientX;
          stopAuto();
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchend',
        function (e) {
          var diff = e.changedTouches[0].clientX - touchX;
          if (Math.abs(diff) > 40) {
            if (diff < 0) next();
            else prev();
          }
          startAuto();
        },
        { passive: true }
      );
    }

    var ioStarted = false;
    function startWhenVisible() {
      layout(0);
      startAuto();
    }

    if (typeof IntersectionObserver !== 'undefined') {
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !ioStarted) {
              ioStarted = true;
              startWhenVisible();
              obs.disconnect();
            }
          });
        },
        { threshold: parseFloat(root.getAttribute('data-tc-io-threshold') || '0.1', 10) }
      );
      obs.observe(root);
    } else {
      startWhenVisible();
    }

    root._tcCleanup = function () {
      stopAuto();
      delete root.dataset.tcInit;
      delete root._tcCleanup;
    };
  }

  function scan(container) {
    (container || document).querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var sec = ev.target;
    if (!sec || typeof sec.querySelector !== 'function') return;
    scan(sec);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var sec = ev.target;
    if (!sec || typeof sec.querySelector !== 'function') return;
    var r = sec.querySelector(SEL);
    if (r && typeof r._tcCleanup === 'function') r._tcCleanup();
  });
})();
